import { Grid16, List16 } from '@carbon/icons-react';
import { Tooltip } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Switcher } from 'components/atoms/switcher';
import { CpSwitcher } from '../../components/cp-switcher';
import {
  Content,
  ContentTitle,
  ContentTitleWrapper,
  Holygrail,
} from '../space/components';
import { CpSpacesListView } from '../space/space-list-view';
import { CpSpacesGridView } from '../space/spaces-grid-view';
import { ListOrGridMode } from '../space/types';
import { CpAccountSpacesSidePane } from './account-spaces-side-pane';
import { CpAccountSpacesProps } from './types';

export const CpAccountSpacesForLaptop: React.FC<CpAccountSpacesProps> = ({
  search,
  currentSpace,
  data,
  mode,
  setMode,
  currentSpaceTabs,
  onSpaceTabClick,
  onSpaceClick,
}) => {
  return (
    <Holygrail>
      <CpAccountSpacesSidePane
        search={search}
        currentSpace={currentSpace}
        onSpaceClick={onSpaceClick}
        data={data}
      />
      <Content fullWidth={!!search?.trim()}>
        {currentSpace ? (
          <>
            <ContentTitleWrapper>
              <ContentTitle>{currentSpace?.spaceName}</ContentTitle>
              <CpSwitcher
                hoverBgColor="white"
                activeColor="black"
                data-mode={mode}
                value={mode}
              >
                <Tooltip title={<FormattedMessage id="cp.list_view" />}>
                  <Switcher.Button
                    checked={mode === ListOrGridMode.List}
                    onClick={() => setMode(ListOrGridMode.List)}
                    value={ListOrGridMode.List}
                  >
                    <List16 />
                  </Switcher.Button>
                </Tooltip>
                <Tooltip title={<FormattedMessage id="cp.grid_view" />}>
                  <Switcher.Button
                    checked={mode === ListOrGridMode.Grid}
                    onClick={() => setMode(ListOrGridMode.Grid)}
                    value={ListOrGridMode.Grid}
                  >
                    <Grid16 />
                  </Switcher.Button>
                </Tooltip>
              </CpSwitcher>
            </ContentTitleWrapper>
            {mode === ListOrGridMode.Grid ? (
              <CpSpacesGridView
                spaceTabs={currentSpaceTabs}
                onSpaceTabClick={onSpaceTabClick}
              />
            ) : (
              <CpSpacesListView
                spaceTabs={currentSpaceTabs}
                onSpaceTabClick={onSpaceTabClick}
              />
            )}
          </>
        ) : (
          <></>
        )}
      </Content>
    </Holygrail>
  );
};
